import { AnanseApiService } from "app/services";
import useAPIErrorHandler from "./useAPIErrorHandler";
import { NotificationPreferences } from "app/types/NotificationPreferences";
import { getUser } from "app/crud";

const useNotificationApi = () => {
  const API_BASE_URL = "/notificationpreferences";
  const api = new AnanseApiService();
  const { loading, error, clearError, handleRequest } = useAPIErrorHandler();

  /**
   * Busca as preferências de notificação de um usuário
   * @param userId ID do usuário
   * @returns Promise com as preferências
   */
  const getPreferences = async (
    userId: number,
  ): Promise<NotificationPreferences> => {
    return handleRequest(async () => {
      const data = await api.makeHttpRequest({
        method: "GET",
        url: `${API_BASE_URL}/${userId}`,
      });
      return data;
    });
  };

  /**
   * Atualiza as preferências de notificação de um usuário
   * @param userId ID do usuário
   * @param preferences Preferências a serem atualizadas
   * @returns Promise com as preferências atualizadas
   */
  const updatePreferences = async (
    userId: number,
    preferences: Partial<NotificationPreferences>,
  ): Promise<NotificationPreferences> => {
    return handleRequest(async () => {
      const data = await api.makeHttpRequest({
        method: "PUT",
        url: `${API_BASE_URL}/${userId}`,
        data: {
          capsuleNotificationStrategy:
            preferences.capsuleNotificationStrategy || 0,
          paymentNotificationStrategy:
            preferences.paymentNotificationStrategy || 0,
          receiveEmailNotifications:
            preferences.receiveEmailNotifications ?? true,
          receivePushNotifications:
            preferences.receivePushNotifications ?? true,
          preferredNotificationTime:
            preferences.preferredNotificationTime || "12:00",
        },
      });
      return data;
    });
  };

  /**
   * Busca os detalhes de um usuário
   * @param userId ID do usuário
   * @returns Promise com os detalhes do usuário
   */
  const getUserDetails = async (userId: number) => {
    return handleRequest(async () => {
      const data = await getUser(userId);
      return data;
    });
  };

  return {
    loading,
    error,
    clearError,
    getPreferences,
    updatePreferences,
    getUserDetails,
  };
};

export default useNotificationApi;
